import React from 'react';

/**
 * Loading state component for list pages
 *
 * Displays a centered spinner while data is loading.
 * Follows theme variables for perfect light/dark theme support.
 *
 * @example
 * {isLoading && <ListPageLoading />}
 */
export interface ListPageLoadingProps {
  /** Loading message (optional) */
  message?: string;
  /** Size of the spinner */
  size?: 'sm' | 'md' | 'lg';
}

export const ListPageLoading: React.FC<ListPageLoadingProps> = ({
  message,
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-10 w-10',
    lg: 'h-16 w-16',
  };

  return (
    <div className="flex flex-col items-center justify-center py-16">
      {/* Spinner */}
      <div
        className={`animate-spin rounded-full border-b-2 ${sizeClasses[size]}`}
        style={{ borderColor: 'var(--theme-button-primary)' }}
      />

      {/* Optional message */}
      {message && (
        <p
          className="mt-4 text-sm"
          style={{ color: 'var(--theme-muted-text)' }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

ListPageLoading.displayName = 'ListPageLoading';
